var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table-component", {
    ref: "table-component",
    attrs: {
      "data-page": "search-list",
      delegate: _vm.delegate,
      title: _vm.t("app-feedback"),
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }